<template>
  <div class="text-start" style="padding: 0.4rem">
    <div class="pb-3 m-3 border-bottom">
      <div class="d-flex flex-wrap justify-content-between align-items-center">
        <h4>
          {{
            $t("borrow.select_number", selectedCount, { count: selectedCount })
          }}
        </h4>
        <div class="d-flex my-2 overflow-auto align-items-center">
          <button
            class="btn-filled secondary-btn me-3 d-flex my-1 flex-shrink-0"
            @click="$router.back()"
          >
            <p>{{ $t("borrow.cancel") }}</p>
          </button>
          <button
            class="btn-filled primary-btn me-3 d-flex my-1 flex-shrink-0"
            @click="confirmSelectAsset"
          >
            <p>{{ $t("borrow.confirm_select") }}</p>
          </button>
        </div>
      </div>
      <div class="d-flex flex-wrap justify-content-between">
        <div class="d-flex flex-wrap">
          <div class="d-flex flex-column m-2">
            <p style="color: #7c7c7c;">
              {{ $t("borrow.borrow_filter_start") }}
            </p>
            <date-picker
              v-model="filter.start_datetime"
              locale="en"
              mode="dateTime"
              is24hr
              :min-date="new Date()"
              :minute-increment="60"
              is-required
              :masks="masks"
            >
              <template v-slot="{ inputValue, togglePopover }">
                <input
                  class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                  :value="inputValue"
                  readonly
                  @click="togglePopover()"
                />
              </template>
            </date-picker>
          </div>
          <div class="d-flex flex-column m-2">
            <p style="color: #7c7c7c;">{{ $t("borrow.borrow_filter_end") }}</p>
            <date-picker
              v-model="filter.end_datetime"
              locale="en"
              mode="dateTime"
              :min-date="filter.start_datetime"
              :validHours="hourIsValidEnd"
              is24hr
              :minute-increment="60"
              is-required
              :masks="masks"
            >
              <template v-slot="{ inputValue, togglePopover }">
                <input
                  class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                  :value="inputValue"
                  readonly
                  @click="togglePopover()"
                />
              </template>
            </date-picker>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="position-relative m-2" style="height: fit-content">
            <input
              v-model="filter.text"
              v-debounce:700ms="loadAsset"
              type="text"
              :placeholder="$t('borrow.search')"
              class="form-control"
              style="padding: 0.75rem 0.75rem 0.75rem 30px; background: #E5E7E7 !important;"
            />
            <img
              class="position-absolute top-50 translate-middle-y"
              style="left: 5px"
              src="../../assets/search-white.svg"
              width="20px"
            />
          </div>
          <button
            class="filter flex-shrink-0"
            type="button"
            id="button-addon2"
            @click="filterModal = true"
          >
            <img src="@/assets/filter-white.svg" />
          </button>
        </div>
      </div>
    </div>
    <add-borrow-table
      ref="BorrowTableRef"
      rowSelection="single"
      :assetData="tableData"
      :otherColumn="otherColumn"
      :page="currentPage"
      :perPage="perPage"
      :searchText="filter.text"
      @selected-count="setSelectedCount"
    ></add-borrow-table>
    <div class="d-flex justify-content-center mt-3">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        aria-controls="my-table"
        @input="loadAsset"
      />
    </div>
    <asset-filter
      :showModal="filterModal"
      @confirm-action="handleFilter"
      @hide-modal="filterModal = false"
    ></asset-filter>
  </div>
</template>

<script>
import axios from "axios";
import { borrowUrl } from "../../util/backend";
import { authHeader } from "../../store/actions";

import AssetFilter from "../../components/BorrowReturn/AssetFilter.vue";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import AddBorrowTable from "../../components/Table/BorrowReturn/AddBorrowTable.vue";
import moment from "moment";
export default {
  components: {
    AddBorrowTable,
    DatePicker,
    AssetFilter,
  },
  data() {
    return {
      id_company: null,
      masks: {
        inputDateTime24hr: "DD/MM/YYYY HH:mm",
      },
      currentPage: 1,
      perPage: 10,
      filterModal: false,
      filter: {
        status: null,
        start_datetime: null,
        end_datetime: null,
        text: null,
        id_category: null,
        id_sub_category: null,
        id_location_building: null,
        id_location_floor: null,
        id_location_department: null,
        id_location_zone: null,
      },
      tableData: [],
      otherColumn: [],
      totalRows: 0,
      selectedCount: 0,
    };
  },
  methods: {
    hourIsValidEnd(hour, dateParts) {
      if (moment(dateParts.date).isSame(this.filter.start_datetime, "d")) {
        return hour > +moment(this.filter.start_datetime).format("H");
      } else {
        return true;
      }
    },
    handleFilter(filter) {
      this.filter = filter;
      this.filterModal = false;
      this.loadAsset();
    },
    setSelectedCount(value) {
      this.selectedCount = value;
    },
    handleStatusFilter(status) {
      this.filter.status = status;
    },
    getSelectedAsset() {
      return this.$refs.BorrowTableRef.selectedRowData;
    },
    confirmSelectAsset() {
      this.$store.dispatch(
        "borrow/setSelectedAssetBorrow",
        this.getSelectedAsset()
      );
      this.$router.back();
    },
    async loadAsset() {
      const id_company = await this.$store.dispatch("getCompanyIdCookie");
      this.id_company = id_company;
      const response = await axios.get(
        `${borrowUrl()}asset/list/company/id/${id_company}`,
        {
          params: {
            ...this.filter,
            page: this.currentPage,
            limit: this.perPage,
            request_status: "AVAILABLE",
          },
          ...authHeader(),
        }
      );
      this.tableData = response.data.results;
      this.totalRows = response.data.item_count;
    },
  },
  created() {
    const storedBorrowDate = this.$store.getters["borrow/getBorrowDateTime"];
    if (storedBorrowDate) {
      this.filter.start_datetime = storedBorrowDate.startDate;
      this.filter.end_datetime = storedBorrowDate.endDate;
    }

    this.loadAsset();
  },
};
</script>

<style lang="scss" scoped>
.btn-filled {
  p {
    margin: 0;
  }
  padding: 10px 15px;
  background-color: #fff;
  border: 2px solid;
  border-radius: 8px;
  &.primary-btn {
    color: #fff;
    background-color: #007afe;
    border-color: #007afe;
  }
  &.secondary-btn {
    color: #fff;
    background-color: #818181;
    border-color: #818181;
  }
}

.filter {
  border-radius: 10px 10px 10px 10px !important;
  background: linear-gradient(180deg, #007afe 0%, #013f81 100%) !important;
  border: none;
  width: 40px;
  height: 40px;
  img {
    padding: 0.3rem;
    width: 40px;
  }
}
</style>
